import { useState } from 'react';
import ai_powered from '../../../assets/reports/ai_powered.png'
import { Carousel } from 'react-bootstrap';
import { PromptCard } from './prompt_card';
import { AnInputBox } from '../../input_utils/AnInput';
import { Button } from '../../cta_utils/AnButton';
import Icon from '../../utils/Icon';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { create_or_update_report } from './api';
import { LoaderComponent } from '../../utils/LoaderComponent';
import ConditionalRender from '../../../ConditionalRender';

export const CreateReport = () => {
    const items = [
        { desc: '“Generate a report summarizing all prospects with their name, company, title, and industry.”', aiIcon: "AiStar1" },
        { desc: '“Generate a report showing all prospects with their education level and the companies they work for.”', aiIcon: "AiStar2" },
        { desc: `“Give me a list of all prospects working in the 'Technology' industry, including their name, title, and company.”`, aiIcon: "AiStar3" },
    ]
    const groupedItems = [];
    for (let i = 0; i < items.length; i += 3) {
        groupedItems.push(items.slice(i, i + 3));
    }
    const [prompt, setPrompt] = useState('')
    const [loader, setLoader] = useState({generateReport: false})
    const history = useHistory();
    const handleGenerateReport = () => {
        setLoader({generateReport: true})
        create_or_update_report({smart_filter_term: prompt}).then((response) => {
            setLoader({generateReport: false})
            history.push({
                pathname: `/reports/${response.data.id}`,
                state: { prompt }
            });
        }).catch((error) => {
            setLoader({generateReport: false})
        })
    }
    return (
        <div style={{ paddingTop: 32 }}>
            <div className='text_center'>
                <img src={ai_powered} style={{width: 88, height: 22}}></img>
                <div className='text_title_big' style={{ paddingTop: 8 }}>Create Report</div>
                <div className='text_subtitle_light' style={{margin: 'auto', maxWidth: '376px'}}>Enter your prompt, and the AI will generate your report with the data and insights you need.</div>
            </div>
            <div className='report_item'>
                <div className='text_subtitle_light_grey_semi_bold' style={{ paddingTop: 32 }}>SAMPLE PROMPTS FOR YOU</div>
            </div>
            <div style={{ maxWidth: 840, margin: 'auto' }}>
                <div style={{ padding: '12px 0px' }}>
                    <Carousel interval={500000} slide={true} indicators={false} variant={'dark'}
                        prevIcon={<span aria-hidden="true" className="" style={{ }} />}
                        nextIcon={<span aria-hidden="true" className="" style={{}} />}
                    >
                        {groupedItems.map((group, index) => (
                            <Carousel.Item key={index}>
                                <div className="default_flex_container" style={{ gap: 10, padding: '0px 42px' }}>
                                    {group.map((item, idx) => (
                                        <PromptCard key={`${index}-${item.aiIcon}`} item={item} />
                                    ))}
                                </div>
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </div>
            </div>
            <div className='report_item'>
                <div>
                    <AnInputBox
                        style={{ 
                            margin: 'auto',
                        }}
                    >
                        <textarea
                            type="text"
                            id="prompt"
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            placeholder="Describe what you want to generate"
                            style={{borderRadius: 8, boxShadow: '2px 2px 6px 0px rgba(0, 0, 0, 0.25), -1px -1px 6px 0px rgba(0, 0, 0, 0.25)', background: '#FAFBFC', border: 'none'}}
                        />
                    </AnInputBox>
                </div>
            </div>
            <div className='report_item'>
            <Button
                buttonSize='Bigger'
                buttonStyle={{ maxWidth: 190, width: '100%', margin: '16px auto' }}
                onClick={() => handleGenerateReport()}
                innerButtonStye={{borderRadius: 24, whiteSpace: 'nowrap', padding: '13px 23px'}}
            >
                {loader.generateReport ? 
                <div className='default_flex_container'>
                    <LoaderComponent loaderStyle={{width: 24, display: 'block', filter: 'brightness(0) invert(1)'}} isLoading={true}></LoaderComponent>
                    <div style={{paddingLeft: 4, fontStyle: 'italic'}}>Generating...</div>
                </div> :
                <div>
                    <Icon name="Stars"/> Generate report
                </div>
                }
            </Button>
            <ConditionalRender if={loader.generateReport}>
                <div className='text_caption text_center'>Your report is being generated, please wait for sometime</div>
            </ConditionalRender>
            </div>
        </div>
    )
}